import { LANG_LABEL, useLang, type Lang } from "./index";

/** Dil seçici: seçim localStorage'a yazılır ve sayfa yeniden yüklenir (modül düzeyi metinler de yenilensin). */
export function LangSwitch({ className = "" }: { className?: string }): JSX.Element {
  const { lang, setLang } = useLang();
  const change = (l: Lang): void => {
    if (l === lang) return;
    setLang(l);
    if (import.meta.env.MODE !== "test") window.location.reload();
  };
  return (
    <span className={`inline-flex gap-1 text-xs ${className}`} role="radiogroup" aria-label="Dil / Language">
      {(Object.keys(LANG_LABEL) as Lang[]).map((l) => (
        <button key={l} type="button" role="radio" aria-checked={lang === l} onClick={() => change(l)} className={`px-1.5 py-0.5 rounded ${lang === l ? "bg-accent text-white" : "text-stone hover:text-accent"}`}>{l.toUpperCase()}</button>
      ))}
    </span>
  );
}
